"use strict";
/*
 * HSStrongPassword
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSStrongPassword = /** @class */ (function (_super) {
    __extends(HSStrongPassword, _super);
    function HSStrongPassword(el, options) {
        var _this = _super.call(this, el, options) || this;
        _this.isOpened = false;
        _this.strength = 0;
        _this.passedRules = new Set();
        var data = el.getAttribute('data-hs-strong-password');
        var dataOptions = data ? JSON.parse(data) : {};
        var concatOptions = __assign(__assign({}, dataOptions), options);
        _this.target = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.target)
            ? typeof (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.target) === 'string'
                ? document.querySelector(concatOptions.target)
                : concatOptions.target
            : null;
        _this.hints = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.hints)
            ? typeof (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.hints) === 'string'
                ? document.querySelector(concatOptions.hints)
                : concatOptions.hints
            : null;
        _this.stripClasses = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.stripClasses) || null;
        _this.minLength = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.minLength) || 6;
        _this.mode = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.mode) || 'default';
        _this.popoverSpace = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.popoverSpace) || 10;
        _this.checksExclude = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.checksExclude) || [];
        _this.availableChecks = [
            'lowercase',
            'uppercase',
            'numbers',
            'special-characters',
            'min-length',
        ].filter(function (el) { return !_this.checksExclude.includes(el); });
        _this.specialCharactersSet =
            (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.specialCharactersSet) ||
                '!"#$%&\'()*+,-./:;<=>?@[\\\\\\]^_`{|}~';
        if (_this.target)
            _this.init();
        return _this;
    }
    HSStrongPassword.prototype.init = function () {
        this.createCollection(window.$hsStrongPasswordCollection, this);
        if (this.availableChecks.length)
            this.build();
    };
    HSStrongPassword.prototype.build = function () {
        var _this = this;
        this.buildStrips();
        if (this.hints)
            this.buildHints();
        this.setStrength(this.target.value);
        this.target.addEventListener('input', function (evt) {
            _this.setStrength(evt.target.value);
        });
    };
    HSStrongPassword.prototype.buildStrips = function () {
        this.el.innerHTML = '';
        if (this.stripClasses) {
            for (var i = 0; i < this.availableChecks.length; i++) {
                var newStrip = (0, utils_1.htmlToElement)('<div></div>');
                (0, utils_1.classToClassList)(this.stripClasses, newStrip);
                this.el.append(newStrip);
            }
        }
    };
    HSStrongPassword.prototype.buildHints = function () {
        var _this = this;
        this.weakness =
            this.hints.querySelector('[data-hs-strong-password-hints-weakness-text]') || null;
        this.rules =
            Array.from(this.hints.querySelectorAll('[data-hs-strong-password-hints-rule-text]')) || null;
        this.rules.forEach(function (rule) {
            var _a;
            var ruleValue = rule.getAttribute('data-hs-strong-password-hints-rule-text');
            if ((_a = _this.checksExclude) === null || _a === void 0 ? void 0 : _a.includes(ruleValue))
                rule.remove();
        });
        if (this.weakness)
            this.buildWeakness();
        if (this.rules)
            this.buildRules();
        if (this.mode === 'popover') {
            this.target.addEventListener('focus', function () {
                _this.isOpened = true;
                _this.hints.classList.remove('hidden');
                _this.hints.classList.add('block');
                _this.recalculateDirection();
            });
            this.target.addEventListener('blur', function () {
                _this.isOpened = false;
                _this.hints.classList.remove('block', 'bottom-full', 'top-full');
                _this.hints.classList.add('hidden');
                _this.hints.style.marginTop = '';
                _this.hints.style.marginBottom = '';
            });
        }
    };
    HSStrongPassword.prototype.buildWeakness = function () {
        var _this = this;
        this.checkStrength(this.target.value);
        this.setWeaknessText();
        this.target.addEventListener('input', function () {
            return setTimeout(function () { return _this.setWeaknessText(); });
        });
    };
    HSStrongPassword.prototype.buildRules = function () {
        var _this = this;
        this.setRulesText();
        this.target.addEventListener('input', function () {
            return setTimeout(function () { return _this.setRulesText(); });
        });
    };
    HSStrongPassword.prototype.setWeaknessText = function () {
        var weaknessText = this.weakness.getAttribute('data-hs-strong-password-hints-weakness-text');
        var weaknessTextToJson = JSON.parse(weaknessText);
        this.weakness.textContent = weaknessTextToJson[this.strength];
    };
    HSStrongPassword.prototype.setRulesText = function () {
        var _this = this;
        this.rules.forEach(function (rule) {
            var ruleValue = rule.getAttribute('data-hs-strong-password-hints-rule-text');
            _this.checkIfPassed(rule, _this.passedRules.has(ruleValue));
        });
    };
    HSStrongPassword.prototype.togglePopover = function () {
        var popover = this.el.querySelector('.popover');
        if (popover)
            popover.classList.toggle('show');
    };
    HSStrongPassword.prototype.checkStrength = function (val) {
        var passedRules = new Set();
        var regexps = {
            lowercase: /[a-z]+/,
            uppercase: /[A-Z]+/,
            numbers: /[0-9]+/,
            'special-characters': new RegExp("[".concat(this.specialCharactersSet, "]")),
        };
        var strength = 0;
        if (this.availableChecks.includes('lowercase') &&
            val.match(regexps['lowercase'])) {
            strength += 1;
            passedRules.add('lowercase');
        }
        if (this.availableChecks.includes('uppercase') &&
            val.match(regexps['uppercase'])) {
            strength += 1;
            passedRules.add('uppercase');
        }
        if (this.availableChecks.includes('numbers') &&
            val.match(regexps['numbers'])) {
            strength += 1;
            passedRules.add('numbers');
        }
        if (this.availableChecks.includes('special-characters') &&
            val.match(regexps['special-characters'])) {
            strength += 1;
            passedRules.add('special-characters');
        }
        if (this.availableChecks.includes('min-length') &&
            val.length >= this.minLength) {
            strength += 1;
            passedRules.add('min-length');
        }
        if (!val.length) {
            strength = 0;
        }
        if (strength === this.availableChecks.length)
            this.el.classList.add('accepted');
        else
            this.el.classList.remove('accepted');
        this.strength = strength;
        this.passedRules = passedRules;
        return {
            strength: this.strength,
            rules: this.passedRules,
        };
    };
    HSStrongPassword.prototype.checkIfPassed = function (el, isRulePassed) {
        if (isRulePassed === void 0) { isRulePassed = false; }
        var check = el.querySelector('[data-check]');
        var uncheck = el.querySelector('[data-uncheck]');
        if (isRulePassed) {
            el.classList.add('active');
            check.classList.remove('hidden');
            uncheck.classList.add('hidden');
        }
        else {
            el.classList.remove('active');
            check.classList.add('hidden');
            uncheck.classList.remove('hidden');
        }
    };
    HSStrongPassword.prototype.setStrength = function (val) {
        var _a = this.checkStrength(val), strength = _a.strength, rules = _a.rules;
        var payload = {
            strength: strength,
            rules: rules,
        };
        this.hideStrips(strength);
        this.fireEvent('change', payload);
        (0, utils_1.dispatch)('change.hs.strongPassword', this.el, payload);
    };
    HSStrongPassword.prototype.hideStrips = function (qty) {
        Array.from(this.el.children).forEach(function (el, i) {
            if (i < qty)
                el.classList.add('passed');
            else
                el.classList.remove('passed');
        });
    };
    // Public methods
    HSStrongPassword.prototype.recalculateDirection = function () {
        if ((0, utils_1.isEnoughSpace)(this.hints, this.target, 'bottom', this.popoverSpace)) {
            this.hints.classList.remove('bottom-full');
            this.hints.classList.add('top-full');
            this.hints.style.marginBottom = '';
            this.hints.style.marginTop = "".concat(this.popoverSpace, "px");
        }
        else {
            this.hints.classList.remove('top-full');
            this.hints.classList.add('bottom-full');
            this.hints.style.marginTop = '';
            this.hints.style.marginBottom = "".concat(this.popoverSpace, "px");
        }
    };
    // Static methods
    HSStrongPassword.getInstance = function (target) {
        var elInCollection = window.$hsStrongPasswordCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection ? elInCollection.element : null;
    };
    HSStrongPassword.autoInit = function () {
        if (!window.$hsStrongPasswordCollection)
            window.$hsStrongPasswordCollection = [];
        document
            .querySelectorAll('[data-hs-strong-password]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsStrongPasswordCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; })) {
                var data = el.getAttribute('data-hs-strong-password');
                var options = data ? JSON.parse(data) : {};
                new HSStrongPassword(el, options);
            }
        });
    };
    return HSStrongPassword;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSStrongPassword.autoInit();
    // Uncomment for debug
    // console.log('Strong password collection:', window.$hsStrongPasswordCollection);
});
document.addEventListener('scroll', function () {
    if (!window.$hsStrongPasswordCollection)
        return false;
    var target = window.$hsStrongPasswordCollection.find(function (el) { return el.element.isOpened; });
    if (target)
        target.element.recalculateDirection();
});
if (typeof window !== 'undefined') {
    window.HSStrongPassword = HSStrongPassword;
}
exports.default = HSStrongPassword;
